var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('LoginForm',{on:{"submit":function($event){return _vm.submit($event)},"forgot":_vm.forgot}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }